import React from 'react';
import './App.css';

import { Home } from './pages/Home/Home.pages';

const App = () => {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
